import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { FarmNoteResponse } from 'src/app/core/models/classes/farm-note-response';
import { Message_Type } from 'src/app/core/models/enums/message-type';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { IGenericConstantModel } from 'src/app/core/models/interfaces/generic-constant-model';
import { IListModalModel } from 'src/app/core/models/interfaces/modal-components-models';
import { INewImageModel } from 'src/app/core/models/interfaces/new-image-model';
import { ClientAlertService } from 'src/app/core/services/client-alert.service';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { DoktarConstantsService } from 'src/app/core/services/doktar-constants.service';
// import { FarmService } from 'src/app/core/services/farm.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { LocationService } from 'src/app/core/services/location.service';
import { MapService } from 'src/app/core/services/map.service';
import { MediaService } from 'src/app/core/services/media.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { FarmMapResponse, IFlagSaveModel } from '../../models/farm-map.model';
import { FarmMapService } from '../../services/farm-map.service';
import { PermissionService } from 'src/app/core/services/permission.service';

@Component({
  selector: 'orbit-add-scouting-note-modal',
  templateUrl: './add-scouting-note-modal.component.html',
  styleUrls: ['./add-scouting-note-modal.component.scss'],
})
export class AddScoutingNoteModalComponent extends BaseModal implements OnInit {

  @Input() flagCoordinates: { lat, lng }
  @Input() currentFarm: FarmMapResponse
  @Input() oldFlagNote: FarmNoteResponse

  markerLastLocation: { lat, lng }
  scoutMap
  locationAvailable: boolean = true
  registerState: "map" | "form" = "map"
  images: Array<INewImageModel> = []
  visibleImageCount = 0
  selectedImage: string = null
  _date = new Date().toISOString()
  toggleModel: boolean = false
  selectedTags: IListModalModel[]
  selectedProblem: IGenericConstantModel
  selectedDate = new Date();
  type: string = "filiz";
  isDisabled: boolean = true;
  constructor(private modalService: ModalService, private dateTimeService: DateTimeService, private alertService: ClientAlertService,
    private mediaService: MediaService, private translate: TranslateService,
    private loadingService: LoadingService, private constantService: DoktarConstantsService,
    private toastService: ToastService, private mapService: MapService, private farmMapService: FarmMapService,
    private storageService: StorageService) {
    super()
    super._modalService = modalService
  }

  ngOnInit() {
    this.storageService.get(StorageKeys.FILIZ_MODE).then(e => {
      if (e.IsSuccess) {
        this.type = e.Data ? "filiz" : "trap";
      }
    });

    if (this.oldFlagNote) {
      this.noteTitle = this.oldFlagNote.Title
      this.noteDescription = this.oldFlagNote.Description
      // this.flagCoordinates = { lat: this.oldFlagNote.Coordinate.lat, lng: this.oldFlagNote.Coordinate.lng }
      this.selectedDate = this.oldFlagNote.FlagDate ? this.dateTimeService.GetMoment(this.oldFlagNote.FlagDate).toDate() : new Date()

      this.constantService.RequestProblemList().subscribe(response => {
        this.selectedProblem = response.find(t => t.ConstantId === this.oldFlagNote.InspectTypeId);
        this.isDisabled = false;
      });
      if (this.selectedProblem) {
        this.constantService.RequestTagList(this.selectedProblem.ConstantId).subscribe(response => {
          let noteTags = this.oldFlagNote.Tags?.map(t => +t)
          this.selectedTags = response.filter(t => noteTags?.some(a => a == t.ConstantId)).map(t => { return { id: t.ConstantId, value: t.ConstantValue } as IListModalModel })
        })
      }

      if (this.oldFlagNote.ImageUrl) {
        this.oldFlagNote.ImageUrl.forEach(el => {
          this.images.push({
            format: "",
            id: el.Id,
            image: null,
            src: el.ImageUrl,
            type: "uploaded",
            mediaType: 'image',
            deleteAction: () => {
              return new Promise((resolve, reject) => {

                this.alertService.confirmAlertController(this.translate.instant("detail.farm-delete")).then(() => {
                  this.alertService.alert.onDidDismiss().then(res => {
                    if (res.role == "true") {
                      this.loadingService.showLoading();
                      let payload = {
                        PhotoId: el.Id
                      }
                      this.mediaService.deleteFarmPhoto(payload).subscribe(res => {
                        this.loadingService.hideLoading();
                        if (res.IsSuccess)
                          resolve(true)
                        else
                          reject(false)
                      }, err => {
                        reject(false)
                      })
                    }
                  })
                })

              })
            }
          })
        })
      }
    }
    this.markerLastLocation = this.flagCoordinates

  }

  dragEndCallback = (ev) => {
    let markerLoc = [ev.target._lngLat.lat, ev.target._lngLat.lng]
    let geojson = JSON.parse(this.currentFarm.GeoJson)
    let reqPolygon = geojson.geometry.coordinates;
    this.locationAvailable = this.mapService.checkIsInPolygon({ coordinates: markerLoc, polygonGeojson: reqPolygon });
    if (this.locationAvailable) {
      this.markerLastLocation = { lat: ev.target._lngLat.lat, lng: ev.target._lngLat.lng };
    }

  }


  mapLoaded(ev) {
    this.scoutMap = ev;
    let geojson = JSON.parse(this.currentFarm.GeoJson)
    this.mapService.fitBounds({ map: this.scoutMap, geojson, padding: { top: 100, right: 10, bottom: 300, left: 10 } })
    this.mapService.addPolygonToMap({ addClickEvent: false, geojson, item: { fillColor: "#fff" }, longPressCallback: null, map: this.scoutMap, polygonId: this.currentFarm.TempFarmAttId + "_scout_map", scope: this, callback: null })
    this.mapService.addMarkerPin({ markerIcon: this.type, coords: { latitude: this.flagCoordinates.lat, longitude: this.flagCoordinates.lng }, currentMarker: null, map: this.scoutMap, scope: this, callback: this.dragEndCallback })
    // this.mapService.followMyLocation({ map: this.scoutMap, icon: null, id: "add-scout-me" })
  }

  followMyLocation

  confirmLocation() {
    let docfn = () => {
      let docContainer = document.getElementById("photosContainer")
      if (docContainer) {
        let visibleMaxImageCount = (docContainer.clientWidth - 10 - 10 - 34 - 34) / 50
        this.visibleImageCount = Math.floor(visibleMaxImageCount) - 1
      } else {
        setTimeout(() => {
          docfn()
        }, 500);
      }
    }

    if ((!this.oldFlagNote || Object.keys(this.oldFlagNote).length == 0)) {
      this.registerState = "form"
      docfn()
      // }
    }
    else {
      this.registerState = "form"
      docfn()
    }
  }

  openCalendar() {
    this.modalService.openCalendarModal(
      {
        title: "",
        isBottomSheet: true,
        min: null,
        options: ModalService.defaultOptionsTransparent,
        preSelected: this.selectedDate,
        startDate: null,
        max: null
      }
    )
      .subscribe(
        response => {
          this.selectedDate = response.date;
        },
        err => {
        }
      )
  }


  openProblemList() {
    this.loadingService.showLoading();
    this.constantService.RequestProblemList().subscribe(response => {
      this.modalService.presentListModal({
        confirmBtnText: this.translate.instant("general.submit"),
        hasConfirmBtn: false,
        isFullscreen: false,
        isMultiple: false,
        showSearchbar:false,
        title: this.translate.instant("add_note.problem_lbl"),
        itemList: response.map(t => {
          let icon = t.AppendixA;
          let color = "gray"
          if (icon) {
            let rawClr = icon.split("&").find(c => c.includes("color"));
            if (rawClr) {
              color = rawClr.replace("color=", "");
              color = color.replace("%23", "#")
            }
          }
          return {
            id: t.ConstantId,
            value: this.translate.instant("constants." + t.ConstantValue),
            isChecked: (this.selectedProblem?.ConstantId === t.ConstantId),
            icon: "ellipse",
            iconSlot: "start",
            iconSource: "ionIcon",
            iconStyle: { color, "font-size": "16px" }
          } as IListModalModel
        })
      }).then(modalRes => {
        this.loadingService.hideLoading()
        modalRes.modalObj.onDidDismiss().then(dismiss => {
          if (dismiss.role === 'itemSelected') {
            this.selectedProblem = response.find(t => t.ConstantId === dismiss.data.selectedItem.id);
            this.selectedTags = [];
            this.isDisabled = false;
          }
        })
      })
    })

  }

  openTagList(constantId) {
    this.loadingService.showLoading();
    if (this.selectedProblem) {
      this.constantService.RequestTagList(constantId).subscribe(response => {
        this.modalService.presentListModal({
          confirmBtnText: this.translate.instant("general.submit"),
          hasConfirmBtn: true,
          isFullscreen: false,
          isMultiple: true,
          showSearchbar:false,
          title: this.translate.instant("add_note.tags_lbl"),
          itemList: response.map(t => {
            return {
              id: t.ConstantId,
              value: this.translate.instant("constants." + t.ConstantValue),
              isChecked: this.selectedTags?.some(a => a.id === t.ConstantId)
            } as IListModalModel
          })
        }).then(modalRes => {
          this.loadingService.hideLoading()
          modalRes.modalObj.onDidDismiss().then(dismiss => {
            if (dismiss.role === 'itemSelected') {
              this.selectedTags = dismiss.data.selectedItem
            }
          })
        })
      })
    }

  }

  openPhotoOptions() {
    this.mediaService.openAddPhotoSheet().subscribe(
      (res: INewImageModel) => {
        this.images = null;
        if (!res) {
          this.images = [];
        } else {
          if (!Array.isArray(this.images))
            this.images = [];
          this.images.push(res);
        }


      }, err => {
      })
  }

  openImagesGallery() {
    this.mediaService.openGalleryModal({ imageList: this.images }).then(response => {
      response.modalObj.onDidDismiss().then(dismiss => {
        if (dismiss && dismiss.role === "imageListChanged") {
          this.images = dismiss.data
        }
      })
    })
  }

  changeToggle(ev) {

  }
  noteTitle
  noteDescription
  saveScoutingNote() {
    let icon = this.selectedProblem.AppendixA;
    let color = "#eeeeee"
    if (icon) {
      let rawClr = icon.split("&").find(c => c.includes("color"));
      if (rawClr) {
        color = rawClr.replace("color=", "");
        color = color.replace("%23", "#")
      }
    }
    let payload: IFlagSaveModel = {
      Description: this.noteDescription,
      FlagDate: this.dateTimeService.formatDate(this.selectedDate, 'YYYY-MM-DD'),
      Id: this.oldFlagNote ? this.oldFlagNote.FlagId : 0,
      InspectTypeId: this.selectedProblem.ConstantId,
      IsFarmerProblem: this.toggleModel,
      Lat: this.markerLastLocation.lat,
      Lon: this.markerLastLocation.lng,
      Tags: Array.isArray(this.selectedTags) ? this.selectedTags.map(t => t.id.toString()).join(",") : "",
      TempFarmAttId: this.currentFarm.TempFarmAttId,
      Title: this.noteTitle
    }

    // "Id": 0,
    // "Description": "string",
    // "Lat": 0,
    // "Lon": 0,
    // "TempFarmAttId": 0,
    // "Title": "string",
    // "FlagDate": "2022-10-17T12:38:35.413Z",
    // "InspectTypeId": 0,
    // "Tags": "string",
    // "IsFarmerProblem": true
    //TODO submit için disabled kontrolü yapılacak
    let images = this.images.filter(e => e.image);
    this.loadingService.showLoading()
    this.farmMapService.addScoutingNote(payload, images).subscribe(el => {
      try {
        if (el) {
          if (Array.isArray(el.flag)) {
            switch (el.flag[0]) {
              case "completed":
                if (Array.isArray(el.images)) {
                  if (el.images[0] === "completed" || el.images[0] === "no_image") {
                    this.dismiss(el.flag[1].Data, "saved")
                  }
                  else {
                    if (el.images[0] !== "start") {
                      this.sendErrorAlert("add_note.error_on_photos_save")
                    }
                  }
                } else {
                  this.sendErrorAlert("add_note.error_on_photos_save")
                }
                break;
              case "failed":
              case "error":
              default:
                this.sendErrorAlert("add_note.error_on_note_save")
                break;
            }
          }
        } else {
          this.sendErrorAlert("add_note.error_on_note_save")
        }
      } catch (error) {
      }
    }, (err) => { }, () => {
      this.loadingService.hideLoading()
    })
  }


  private sendErrorAlert(title) {
    this.toastService.PresentBasicToast({
      message: this.translate.instant("add_note.error_on_note_save"),
      type: Message_Type.DANGER,
      duration: 3500
    })
    // this.alertService.PresentAlert({
    //   buttons: [{
    //     callback: () => { },
    //     color: 'dark',
    //     fill: 'clear',
    //     text: this.translate.instant("general.close_alert")
    //   }],
    //   title: this.translate.instant("add_note.error_on_note_save")
    // })
  }

  // locateMe() {
  //   let coords = LocationService.currentCoords.coords;
  //   this.mapService.flyToLocation({ map: this.scoutMap, latitude: coords.latitude, longitude: coords.longitude, scope: this, zoom: 18 })
  // }

  locateMe() {
    PermissionService.CheckAndRequestLocation({
      granted: () => {
        let coords = LocationService.currentCoords.coords;
        this.mapService.flyToLocation({ map: this.scoutMap, latitude: coords.latitude, longitude: coords.longitude, scope: this, zoom: 18 })
      }, rejected: () => {
        PermissionService.instanceOfService.permissionDeniedAlert("location")
      }
    })
  }
}
